import { useContext } from 'react';
import { AnalyticsContext } from './analytics-context.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useAnalytics = /* @__PURE__ */ __name(() => useContext(AnalyticsContext), "useAnalytics");

export { useAnalytics };
//# sourceMappingURL=use-analytics.js.map
